"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavIssuanceModule__factory = void 0;
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "contract IController",
                name: "_controller",
                type: "address",
            },
            {
                internalType: "contract IWETH",
                name: "_weth",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_feeRecipient",
                type: "address",
            },
        ],
        name: "FeeRecipientEdited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_newManagerFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
        ],
        name: "ManagerFeeEdited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_newPremium",
                type: "uint256",
            },
        ],
        name: "PremiumEdited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_newReserveAsset",
                type: "address",
            },
        ],
        name: "ReserveAssetAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_removedReserveAsset",
                type: "address",
            },
        ],
        name: "ReserveAssetRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_issuer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_hookContract",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_setTokenQuantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_managerFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_premium",
                type: "uint256",
            },
        ],
        name: "SetTokenNAVIssued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_redeemer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_hookContract",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_setTokenQuantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_managerFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_premium",
                type: "uint256",
            },
        ],
        name: "SetTokenNAVRedeemed",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
        ],
        name: "addReserveAsset",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "controller",
        outputs: [
            {
                internalType: "contract IController",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_managerFeeRecipient",
                type: "address",
            },
        ],
        name: "editFeeRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_managerFeePercentage",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_managerFeeIndex",
                type: "uint256",
            },
        ],
        name: "editManagerFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_premiumPercentage",
                type: "uint256",
            },
        ],
        name: "editPremium",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_setTokenQuantity",
                type: "uint256",
            },
        ],
        name: "getExpectedReserveRedeemQuantity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_reserveAssetQuantity",
                type: "uint256",
            },
        ],
        name: "getExpectedSetTokenIssueQuantity",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_reserveAssetQuantity",
                type: "uint256",
            },
        ],
        name: "getIssuePremium",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_managerFeeIndex",
                type: "uint256",
            },
        ],
        name: "getManagerFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_setTokenQuantity",
                type: "uint256",
            },
        ],
        name: "getRedeemPremium",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
        ],
        name: "getReserveAssets",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "contract INAVIssuanceHook",
                        name: "managerIssuanceHook",
                        type: "address",
                    },
                    {
                        internalType: "contract INAVIssuanceHook",
                        name: "managerRedemptionHook",
                        type: "address",
                    },
                    {
                        internalType: "address[]",
                        name: "reserveAssets",
                        type: "address[]",
                    },
                    {
                        internalType: "address",
                        name: "feeRecipient",
                        type: "address",
                    },
                    {
                        internalType: "uint256[2]",
                        name: "managerFees",
                        type: "uint256[2]",
                    },
                    {
                        internalType: "uint256",
                        name: "maxManagerFee",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "premiumPercentage",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "maxPremiumPercentage",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "minSetTokenSupply",
                        type: "uint256",
                    },
                ],
                internalType: "struct NavIssuanceModule.NAVIssuanceSettings",
                name: "_navIssuanceSettings",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_reserveAssetQuantity",
                type: "uint256",
            },
        ],
        name: "isIssueValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_setTokenQuantity",
                type: "uint256",
            },
        ],
        name: "isRedeemValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isReserveAsset",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_reserveAssetQuantity",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_minSetTokenReceiveQuantity",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
        ],
        name: "issue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_minSetTokenReceiveQuantity",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
        ],
        name: "issueWithEther",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "",
                type: "address",
            },
        ],
        name: "navIssuanceSettings",
        outputs: [
            {
                internalType: "contract INAVIssuanceHook",
                name: "managerIssuanceHook",
                type: "address",
            },
            {
                internalType: "contract INAVIssuanceHook",
                name: "managerRedemptionHook",
                type: "address",
            },
            {
                internalType: "address",
                name: "feeRecipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "maxManagerFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "premiumPercentage",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxPremiumPercentage",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "minSetTokenSupply",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_setTokenQuantity",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_minReserveReceiveQuantity",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
        ],
        name: "redeem",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_setTokenQuantity",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_minReserveReceiveQuantity",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "_to",
                type: "address",
            },
        ],
        name: "redeemIntoEther",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "removeModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_reserveAsset",
                type: "address",
            },
        ],
        name: "removeReserveAsset",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "weth",
        outputs: [
            {
                internalType: "contract IWETH",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
var _bytecode = "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";
var NavIssuanceModule__factory = /** @class */ (function (_super) {
    __extends(NavIssuanceModule__factory, _super);
    function NavIssuanceModule__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    NavIssuanceModule__factory.prototype.deploy = function (_controller, _weth, overrides) {
        return _super.prototype.deploy.call(this, _controller, _weth, overrides || {});
    };
    NavIssuanceModule__factory.prototype.getDeployTransaction = function (_controller, _weth, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _controller, _weth, overrides || {});
    };
    NavIssuanceModule__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    NavIssuanceModule__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    NavIssuanceModule__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    NavIssuanceModule__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    NavIssuanceModule__factory.bytecode = _bytecode;
    NavIssuanceModule__factory.abi = _abi;
    return NavIssuanceModule__factory;
}(ethers_1.ContractFactory));
exports.NavIssuanceModule__factory = NavIssuanceModule__factory;
//# sourceMappingURL=NavIssuanceModule__factory.js.map